import { divIcon, point } from "leaflet";
import IconCustom from "../../../../util/awesome-markers-wrapper";

// creates a custom icon for multiple records existing at the same location
// it creates a Leaflet.awesome-markers icon with custom HTML that displays the count of records
export const multipleRecordsIcon = count => {
  const style = `
        font-size: 14px;
        font-weight: bold;
        // font-family: Arial, sans-serif;
        `;
  // IconCustom is extended from L.AwesomeMarkers.Icon - we added functionality to display custom html
  return IconCustom({
    icon: "",
    prefix: "fa",
    markerColor: "orange",
    html: `<div style="${style}">${count}</div>`,
    iconStyle: `margin-top: 7px;font-style: normal;`
  });
};

// creates a custom icon for a cluster of markers that are close together.
// it uses Leaflet's divIcon to create an icon with custom HTML content that displays the count of markers.
export const clusterMarkersIcon = count => {
  let fontSize;

  if (count >= 10000) {
    fontSize = "1rem";
  } else if (count >= 100) {
    fontSize = "1.2rem";
  } else {
    fontSize = "1.4rem";
  }

  const style = `
      position: relative;
      background-color: orange;
      height: 50px;
      width: 50px;
      border-radius: 50%;
      box-shadow: 0 0 0px 2px #fff;
      opacity: 0.6;
  `;

  const spanStyle = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: ${fontSize};
  `;

  return divIcon({
    html: `<div style="${style}"><span style="${spanStyle}">${count}</span></div>`,
    className: "dummy",
    iconSize: point(50, 50, true)
  });
};
